module.exports = __webpack_public_path__ + "static/media/image9.0f635a41.png";